module.exports = __webpack_public_path__ + "static/media/photo7.5bcd225f.jpg";